import { Dialog } from "@minuthq/meatball-ui-react"

import { usePostTaskTemplateDeleted } from "src/data/analytics/queries/taskManagementAnalyticsQueries"
import { TTaskTemplate } from "src/data/taskManagement/taskManagementTypes"
import { useDeleteTaskTemplate } from "src/data/taskManagement/taskTemplateQueries"
import { useTranslate } from "src/i18n/useTranslate"

export function DeleteTaskTemplateDialog({
  template,
  onClose,
}: {
  template: TTaskTemplate
  onClose: () => void
}) {
  const { t, langKeys } = useTranslate()

  const deleteTaskTemplate = useDeleteTaskTemplate()
  const postTaskTemplateDeleted = usePostTaskTemplateDeleted()

  function handleDelete() {
    deleteTaskTemplate.mutate(
      {
        path: {
          organization_id: template.organization_id,
          task_template_id: template.template_id,
        },
      },

      {
        onSuccess: () => {
          postTaskTemplateDeleted.mutate({
            task_type: template.task_category,
          })
          onClose()
        },
      }
    )
  }

  return (
    <Dialog
      open={true}
      onClose={onClose}
      title={t(langKeys.task_management_delete_template_action)}
      confirmLabel={t(langKeys.delete)}
      onConfirm={handleDelete}
      confirmButtonProps={{
        color: "destructive",
      }}
      closeLabel={t(langKeys.cancel)}
      error={
        deleteTaskTemplate.isError && t(langKeys.failed_general_error_title)
      }
      loading={deleteTaskTemplate.isLoading}
      description={t(langKeys.task_management_delete_template_prompt)}
    />
  )
}
